import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Globe } from 'lucide-react';

export const AUTO = 'auto';
export const GLOBAL = 'Global';
const STORAGE_KEY = 'spendlens_benchmark_country';

export const loadCountryChoice = () => localStorage.getItem(STORAGE_KEY) || AUTO;
export const saveCountryChoice = (v) => localStorage.setItem(STORAGE_KEY, v);

// Explains where the benchmark country came from
export function countrySourceLabel(d) {
  if (!d) return '';
  const opts = d.country_options || [];
  switch (d.country_source) {
    case 'selected': return 'your selection';
    case 'organization': return 'organisation setting';
    case 'dominant': return `${opts[0]?.share_pct}% of your spend`;
    case 'multi_country': return `spend spread across ${opts.length} countries`;
    default: return 'no country data';
  }
}

export function BenchmarkCountrySelect({ value, options, orgCountry, onChange }) {
  const countries = [...(options || [])];
  if (orgCountry && !countries.some((o) => o.country === orgCountry)) countries.unshift({ country: orgCountry });
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-[210px] h-8 text-xs" data-testid="benchmark-country-selector">
        <Globe className="w-3.5 h-3.5 mr-1.5 text-muted-foreground shrink-0" />
        <SelectValue placeholder="Benchmark country" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={AUTO} data-testid="benchmark-country-auto">Auto (recommended)</SelectItem>
        <SelectItem value={GLOBAL} data-testid="benchmark-country-global">Global</SelectItem>
        {countries.map((o) => (
          <SelectItem key={o.country} value={o.country} data-testid={`benchmark-country-${o.country.replace(/\s+/g, '-').toLowerCase()}`}>
            {o.country}{o.country === orgCountry ? ' (org)' : ''}{o.share_pct != null ? ` · ${o.share_pct}%` : ''}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
